var _classCallCheck = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PRELOADED_CLOUDINARY_PATH, config, utils;
utils = require("./utils");
config = require("./config");
PRELOADED_CLOUDINARY_PATH = /^([^\/]+)\/([^\/]+)\/v(\d+)\/([^#]+)#([^\/]+)$/;

var PreloadedFile = /*#__PURE__*/function () {
  "use strict";

  function PreloadedFile(file_info) {
    _classCallCheck(this, PreloadedFile);

    var matches, public_id_and_format;
    matches = file_info.match(PRELOADED_CLOUDINARY_PATH);

    if (!matches) {
      throw "Invalid preloaded file info";
    }

    this.resource_type = matches[1];
    this.type = matches[2];
    this.version = matches[3];
    this.filename = matches[4];
    this.signature = matches[5];
    public_id_and_format = PreloadedFile.split_format(this.filename);
    this.public_id = public_id_and_format[0];
    this.format = public_id_and_format[1];
  }

  _createClass(PreloadedFile, [{
    key: "is_valid",
    value: function is_valid() {
      var expected_signature;
      expected_signature = utils.api_sign_request({
        public_id: this.public_id,
        version: this.version
      }, config().api_secret);
      return this.signature === expected_signature;
    }
  }, {
    key: "identifier",
    value: function identifier() {
      return "v".concat(this.version, "/").concat(this.filename);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.resource_type, "/").concat(this.type, "/v").concat(this.version, "/").concat(this.filename, "#").concat(this.signature);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this = this;

      var result = {};
      Object.getOwnPropertyNames(this).forEach(function (key) {
        var val = _this[key];

        if (typeof val !== 'function') {
          result[key] = val;
        }
      });
      return result;
    }
  }], [{
    key: "split_format",
    value: function split_format(identifier) {
      var format, last_dot, public_id;
      last_dot = identifier.lastIndexOf(".");

      if (last_dot === -1) {
        return [identifier, null];
      }

      public_id = identifier.substr(0, last_dot);
      format = identifier.substr(last_dot + 1);
      return [public_id, format];
    }
  }]);

  return PreloadedFile;
}();

module.exports = PreloadedFile;